import { render, staticRenderFns } from "./SGPFiltroComponent.vue?vue&type=template&id=2b74b470"
import script from "./SGPFiltroComponent.vue?vue&type=script&lang=js"
export * from "./SGPFiltroComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports